export const addressSchema = {
  properties: {
    woj: {
      default: 'lubelskie',
      title: 'Województwo',
      type: 'string',
      fieldRequired: true
    },

    pow: {
      default: 'Lublin',
      title: 'Powiat',
      type: 'string',
      fieldRequired: true
    },

    gmi: {
      default: 'gmina miejska Lublin',
      title: 'Gmina',
      type: 'string',
      fieldRequired: true
    },

    simc: {
      title: 'Miejscowość',
      type: 'string',
      fieldRequired: true
    },

    terc: {
      calc: {
        func: '"066301"',
        when: '!this.terc'
      },
      title: 'Kod TERC',
      type: 'string',
      fieldRequired: true
    },

    ulic: {
      title: 'Kod ULIC',
      type: 'string',
      fieldRequired: false
    },

    street: {
      title: 'Ulica',
      type: 'string',
      fieldRequired: '(this.terc === "066301" || this.terc === "0663011")',
      warnings: {
        validFunc: '!this.street || !!this.ulic',
        warningMessages: {
          validFunc:
            'Uwaga: Wprowadzono ulicę spoza bazy ulic. ' +
            'Upewnij się, czy ulica na pewno została wprowadzona prawidłowo.'
        }
      }
    },

    city: {
      title: 'Miejscowość',
      type: 'string',
      fieldRequired: true
    },

    nr: {
      title: 'Numer posesji',
      type: 'string',
      fieldRequired: '(this.terc === "066301" || this.terc === "0663011")'
    },

    localNr: {
      title: 'Numer lokalu',
      type: 'string'
    },

    postCode: {
      format: 'kod',
      title: 'Kod pocztowy',
      type: 'string',
      fieldRequired: true
    },

    post: {
      default: 'Lublin',
      title: 'Poczta',
      type: 'string',
      fieldRequired: true
    },

    formattedAddress: {
      calc: [
        'const commaValues = [this.post, this.postCode, this.street || this.city];',
        'return [',
        '  commaValues.filter(Boolean).join(", "),',
        '  this.nr ? this.nr + (this.localNr ? "/" + this.localNr : "") : ""',
        ']',
        '.filter(Boolean)',
        '.join(" ");'
      ],
      type: 'string'
    }
  },

  title: 'Adres',
  type: 'object'
};
